import { ErrorCode, FileRejection } from 'react-dropzone';
import { readCommonConfig } from '../commons/config';
import { ProgramAttachment } from '../program/types';

export const hasErrorOfType = (fileRejections: FileRejection[], errorCode: ErrorCode) =>
  fileRejections.some((x) => x.errors.some((e) => e.code === errorCode));

export const getFileExtension = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf('.');
  return lastDotIndex === -1 ? '' : filename.substring(lastDotIndex + 1);
};

const extensionToMimeType = (fileExtension: string): string => {
  switch (fileExtension) {
    case 'bmp':
      return 'image/bmp';
    case 'csv':
      return 'text/csv';
    case 'gif':
      return 'image/gif';
    case 'htm':
      return 'text/htm';
    case 'html':
      return 'text/html';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'pdf':
      return 'application/pdf';
    case 'png':
      return 'image/png';
    case 'tiff':
    case 'tif':
      return 'image/tiff';
    case 'txt':
      return 'text/plain';
    default:
      return 'application/octet-stream';
  }
};

export const calculateContentType = (x: ProgramAttachment) => {
  if (x.contentType === 'application/octet-stream') {
    const fileExtension = getFileExtension(x.name);
    return extensionToMimeType(fileExtension.toLowerCase());
  }
  return x.contentType;
};

export const saveDownloadFile = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(new File([blob], fileName));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
export const downloadFile = async (url: string, fileName: string): Promise<void> => {
  const finalUrl = url.replace('[BACKEND_API]', readCommonConfig().backendApiUrl);
  const response = await fetch(finalUrl, { mode: 'cors' });
  if (!response.ok) {
    throw new Error(`Failed to fetch file: ${response.statusText}`);
  }
  const blob = await response.blob();
  saveDownloadFile(blob, fileName);
};
